import { Link } from "react-router-dom";

interface SlabProps {
  className?: string;
  rank?: any;
  src?: string;
  alt?: string;
  name?: any;
  Countdown?: any;
  Category?: string;
  Subcategory?: string;
  Fan1?: React.ReactNode;
  Value?: React.ReactNode;
  Price?: React.ReactNode;
  Button?: React.ReactNode;
  icon?: React.ReactNode;
  content?: React.ReactNode;
  bgcolor?: string;
  withBadge?: boolean;
  onClick?: () => void;
  fanId?: any;
  figId?: any;
}

const Slab: React.FC<SlabProps> = ({
  className,
  rank,
  src,
  alt,
  name,
  Countdown,
  Category,
  Subcategory,
  Fan1,
  Value,
  Price,
  Button,
  icon,
  content,
  bgcolor = "bg-midnight",
  withBadge = false,
  onClick,
  figId,
  fanId,
}) => {
  return (
    <>
      <div
        onClick={onClick}
        className={`slab-view ${
          withBadge ? "position-relative " : ""
        }${className}`}
      >
        {rank && (
          <h4 className={`${withBadge ? "circle-rank-id" : "rank-id"} me-4`}>
            {rank}
          </h4>
        )}
        <div className={`details col ${bgcolor}`}>
          {!content && (
            <div className="col-5 d-flex">
              {src !== "" ? (
                <img src={src} alt={alt} className="image" />
              ) : (
                <div
                  style={{ borderRadius: "4px 4px 0px 0px" }}
                  className={`default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center mx-auto chat-image`}
                >
                  <i className="fa-solid fa-user" style={{ fontSize: 20 }}></i>
                </div>
              )}
              <div className="name">
                {figId ? (
                  <Link
                    className="text-decoration-none purple-color"
                    to={`/${figId}`}
                  >
                    {name}
                  </Link>
                ) : (
                  <>{name}</>
                )}
              </div>
            </div>
          )}
          {content && <>{content}</>}

          {Category && (
            <div className="col py-auto text-start ms-2 font-inter-500-16">
              {" "}
              {Category}{" "}
            </div>
          )}

          {Subcategory && (
            <div className="col py-auto text-start ms-2 font-inter-500-16">
              {" "}
              {Subcategory}{" "}
            </div>
          )}

          {Fan1 && (
            <div className="col py-auto text-start ms-2 font-inter-500-16">
              {fanId ? (
                <Link
                  className="text-decoration-none text-white font-inter-500-16"
                  to={`/${fanId}`}
                >
                  {Fan1}
                </Link>
              ) : (
                <>{Fan1}</>
              )}
            </div>
          )}

          {Price && (
            <div className="col py-auto text-start ms-2 font-inter-500-16">
              {" "}
              {Price}{" "}
            </div>
          )}
          {Value && (
            <div className="col py-auto text-start ms-2 font-inter-500-16">
              {" "}
              {Value}{" "}
            </div>
          )}
          {Countdown && (
            <div className="col py-auto text-start font-inter-500-16">
              {" "}
              {Countdown}{" "}
            </div>
          )}

          {Button && <div className="col-2 my-auto">{Button}</div>}

          {icon && <div className="col-1 my-auto">{icon}</div>}
        </div>
      </div>
    </>
  );
};

export default Slab;
